"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = withDisabledContext;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _getComponentName = _interopRequireDefault(require("react-utils/getComponentName"));

var _Disableable = require("../toolbar/Disableable");

function withDisabledContext(WrappedComponent) {
  var WithDisabled =
  /*#__PURE__*/
  function (_Component) {
    (0, _inherits2.default)(WithDisabled, _Component);

    function WithDisabled() {
      (0, _classCallCheck2.default)(this, WithDisabled);
      return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(WithDisabled).apply(this, arguments));
    }

    (0, _createClass2.default)(WithDisabled, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            disabled = _this$props.disabled,
            props = (0, _objectWithoutProperties2.default)(_this$props, ["disabled"]);
        return _react.default.createElement(WrappedComponent, (0, _extends2.default)({
          disabled: disabled || this.context || false
        }, props));
      }
    }]);
    return WithDisabled;
  }(_react.Component);

  WithDisabled.contextType = _Disableable.DisabledContext;
  WithDisabled.displayName = "WithDisabled(" + (0, _getComponentName.default)(WrappedComponent) + ")";
  return WithDisabled;
}

module.exports = exports.default;